export default "__VITE_ASSET__BBSVO_ix__"